// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EuroCircleTwoToneSvg from "@fishx/icons-svg/es/asn/EuroCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var EuroCircleTwoTone = function EuroCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EuroCircleTwoToneSvg
  }));
};

EuroCircleTwoTone.displayName = 'EuroCircleTwoTone';
export default React.forwardRef(EuroCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EuroCircleTwoTone.js
// module id = 2613
// module chunks = 0